module.exports = __webpack_public_path__ + "static/media/img10.ed1c1ee8.jpg";